<template>
    <footer class="footer-area" id="suporte">
        <div class="footer-bg"></div>
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2">
                    <div class="newsletter text-center">
                        <h3><i class="fa fa-phone"></i> Ligue: {{ app.telefone }}</h3>
                        <form action="/cadastro" method="get" id="cadastro-rodape">
                            <div class="newsletter-content">
                                <input type="text" name="email" class = "required" placeholder="Entre com seu e-mail">
                                <button type="submit" class="button"><span class = "visible-xs">>></span><span class = "hidden-xs">Experimentar</span></button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-3">
                    <div class="footer-links text-center">
                        <a
                            v-if="app.facebook" 
                            :href="app.facebook" 
                            target = "_blank"
                        >
                                <i class="zmdi zmdi-facebook"/>
                        </a>
                        <a 
                            v-if="app.instagram" 
                            :href="app.instagram" 
                            target = "_blank"
                        >
                                <i class="zmdi zmdi-instagram"/>
                        </a>
                        <a 
                            v-if="app.twitter" 
                            :href="app.twitter" 
                            target = "_blank"
                        >
                                <i class="zmdi zmdi-twitter"/>
                        </a>
                        <a 
                            v-if="app.google_mais" 
                            :href="app.google_mais" 
                            target = "_blank"
                        >
                                <i class="zmdi zmdi-google"/>
                        </a>
                        <a 
                            v-if="app.youtube" 
                            :href="app.youtube" 
                            target = "_blank"
                        >
                                <i class="zmdi zmdi-youtube"/>
                        </a>
                        <a 
                            v-if="app.linkedin" 
                            :href="app.linkedin" 
                            target = "_blank"
                        >
                                <i class="zmdi zmdi-linkedin"/>
                                <!-- <i class="zmdi zmdi-linkedin-box"/> -->
                        </a>
                    </div>
                    <div class="footer-text text-center">
                        <span>Copyright &copy; {{ new Date().getFullYear() }} - {{ app.nome }}</span>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    props: ['app'],
}
</script>